<script setup>
import { computed, onMounted, watch } from "vue";
import { useRoute } from "vue-router";
import HrPayrollMark from "@/components/branding/hr-payroll-mark.vue";
import { useAuthStore } from "@/stores/authStore";
import { resolveHomeLabel, resolveHomeRoute } from "@/utils/homeRoute";

const route = useRoute();
const auth = useAuthStore();

const homeRoute = computed(() => resolveHomeRoute(auth));
const homeLabel = computed(() => resolveHomeLabel(auth));

const isExplicit404 = computed(() => route.name === "error-404");

function updateBodyClass() {
  document.body.classList.toggle(
    "bg-linear-gradiant",
    route.name === "error-404" || route.name === "not-found"
  );
}

onMounted(updateBodyClass);
watch(() => route.path, updateBodyClass);
</script>

<template>
  <div class="container">
    <div class="vh-100 d-flex align-items-center">
      <div class="row justify-content-center align-items-center w-100">
        <div class="col-md-4 d-flex justify-content-center align-items-center">
          <div>
            <div class="mb-5">
              <hr-payroll-mark variant="full" />
            </div>
            <div>
              <p class="text-muted mb-2">404</p>
              <h1 class="mb-3">Page not found</h1>
              <p class="fs-16 text-muted">
                {{
                  isExplicit404
                    ? "The page you requested does not exist or may have been moved."
                    : "We could not find a page at this address. Check the URL or return to your dashboard."
                }}
              </p>
              <div class="d-flex flex-wrap gap-2">
                <router-link
                  :to="homeRoute"
                  class="btn btn-primary d-inline-flex align-items-center"
                >
                  <i class="ti ti-arrow-left me-2"></i>{{ homeLabel }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 d-flex justify-content-end align-items-center">
          <div class="error-images">
            <img
              src="@/assets/img/bg/error-404.svg"
              alt="Page not found"
              class="img-fluid"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
